import SettingMenu from './SettingMenu';
import CallSettings from './CallSettings';
import { useSelector } from 'react-redux';
import EmailSignatureSettings from './EmailSignatureSettings';


const SettingPages = () => {
    const selectedMenu = useSelector((state:any)=>{return state.settingSlice.selectedMenu})
    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    return (
        <div className="main-content">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                        <SettingMenu />
                    </div>
                    <div className='col-md-9'>
                        {selectedMenu === 'Call' && <CallSettings />}
                        {selectedMenu === 'EmailSignature' && <EmailSignatureSettings />}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SettingPages;
